import React, { FC } from 'react';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { Button, Grid, Box, MenuItem } from '@mui/material';
import { FieldText } from '../../../components/fields/Text/Text';
import { usertypeOptions } from '../../../components/SingleFilter';
import { FieldSelect } from '../../../components/fields/Select';
// import { FieldImageUpload } from '../../../components/fields/ImageUpload/ImageUpload';


interface IUser {
  userid: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  displayName: string;
  usertype: string;
}

interface Props {
  user?: IUser;
  handleSubmit: any;
}

const registrationSchema = yup.object().shape({
  'emailAddress': yup.string().email().required(),
  'password': yup.string(),
  // 'displayName': yup.string().required(),
  'usertype': yup.string().required(),
})

const UserEditForm: FC<Props> = ( { user, handleSubmit } ) => {

  const initValues = {
    avatar: '',
    ...( user || {} ),
  }

  // const handleImageChange = ( value:any ) => {
  //   console.log( value );
  //   const avatar = value.source ? value.source : value;
  //   initValues.avatar = avatar;
  // }

  return (
    <Formik initialValues={initValues} enableReinitialize onSubmit={handleSubmit} validationSchema={ registrationSchema }>
      {({ isSubmitting }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FieldText
                name="emailAddress"
                label="Email"
                placeholder="name@example.com"
                fullWidth
                required
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} md={6}>
              <FieldText
                name="password"
                label="Password"
                placeholder="password123"
                type='password'
                fullWidth />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6} md={4}>
              <FieldText name="firstName" label="First Name" placeholder="First Name" fullWidth />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FieldText name="lastName" label="Last Name" placeholder="Last Name" fullWidth />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6} md={4}>
              <FieldSelect name="usertype" label='User Type' required fullWidth >
                { usertypeOptions.map( e => (
                  <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                ) ) }
              </FieldSelect>
            </Grid>
          </Grid>
          <Box sx={{ mt: { xs: 4, sm: 6 } }}>
            <Button
              size="large"
              type="submit"
              variant="contained"
              disabled={isSubmitting}
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              Save
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default UserEditForm;